import {
  deselectedEyeIcon,
  selectedEyeIcon,
  starHighlightedIcon,
  starUnHighlightedIcon,
} from '../../styles';
import { IVppaService } from '../../services/vppa.service';

export enum ActionTypes {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  COPY = 'COPY',
  DELETE = 'DELETE',
  FAVORITE = 'FAVORITE',
  DESELECT = 'DESELECT',
  COMPARE = 'COMPARE',
  REVIEW = 'REVIEW',
  REJECT = 'REJECT',
  REQUIRES_CONFIRMATION = 'REQUIRES_CONFIRMATION',
  SUCCESSFUL = 'SUCCESSFUL',
  FILTER = 'FILTER',
  IN_PROGRESS = 'IN_PROGRESS',
  DOWNLOAD = 'DOWNLOAD',
}

interface IAction {
  name: string;
  callback: (any?) => void;
  type: ActionTypes;
  actionName: string;
  disabled?: boolean;
  tooltip?: string;
}

interface IAgGridActions {
  actions: IAction[];
}

export class ActionCellRenderer {
  @IVppaService vppaService: IVppaService;
  content: HTMLElement;
  leftButtons: HTMLElement;
  rightButtons: HTMLElement;

  constructor() {
    this.content = document.createElement('div');
    this.leftButtons = document.createElement('div');
    this.rightButtons = document.createElement('div');
    this.content.appendChild(this.leftButtons);
    this.content.appendChild(this.rightButtons);
  }

  init(params: IAgGridActions) {
    this.renderButtons(params);
  }

  renderButtons(params) {
    const { actions, data, enabled } = params;
    if (!enabled) return;
    this.content.setAttribute('part', 'actionWrapper');
    this.leftButtons.setAttribute('part', 'leftButtons');
    this.rightButtons.setAttribute('part', 'rightButtons');
    if (!actions || actions.length < 1) return;

    actions.forEach((action: IAction) => {
      const button: HTMLButtonElement = document.createElement('zero-button') as HTMLButtonElement;
      button.disabled = action.disabled;
      button.type = 'button';
      button.innerHTML = action.name;

      if (action.type === ActionTypes.FAVORITE) {
        this.vppaService.getWatchlistVppa(data).then((response) => {
          let isClicked = false;
          if (response.REPLY.length > 0) {
            isClicked = true;
            button.innerHTML = starHighlightedIcon();
            button.title = 'Remove from Watchlist';
          }
          function onFavoriteWatchlist() {
            isClicked = !isClicked;
            data.isClicked = isClicked;
            action.callback(data);
            if (isClicked) {
              button.innerHTML = starHighlightedIcon();
              button.title = 'Remove from Watchlist';
            } else {
              button.innerHTML = starUnHighlightedIcon();
              button.title = 'Add to Watchlist';
            }
          }
          button.addEventListener('click', onFavoriteWatchlist);
        });
      } else {
        button.addEventListener('click', () => {
          action.callback(data);
        });
      }

      if (action.type === ActionTypes.DESELECT) {
        let isClicked = false;
        function onDeselect() {
          isClicked = !isClicked;
          data.isClicked = isClicked;
          if (isClicked) {
            button.innerHTML = deselectedEyeIcon();
          } else {
            button.innerHTML = selectedEyeIcon();
          }
        }
        button.addEventListener('click', onDeselect);
      }

      if (action.tooltip) {
        button.title = action.tooltip;
      }

      button.style.fontSize = '12px';
      button.style.color =
        action.type === ActionTypes.EDIT || action.type === ActionTypes.REVIEW
          ? '#FFB661'
          : action.type == ActionTypes.DELETE
          ? '#F9644D'
          : '#FFFFFF';

      if (action.type === ActionTypes.CREATE) {
        button.setAttribute('part', 'gridButton');
        this.leftButtons.appendChild(button);
      } else if (action.type === ActionTypes.REVIEW) {
        button.setAttribute('part', 'awaitingConfirmationButton');
        this.leftButtons.appendChild(button);
      } else if (action.type === ActionTypes.REJECT) {
        button.setAttribute('part', 'rejectTradeButton');
        this.leftButtons.appendChild(button);
      } else if (action.type === ActionTypes.REQUIRES_CONFIRMATION) {
        button.setAttribute('part', 'confirmTradeButton');
        this.leftButtons.appendChild(button);
      } else if (action.type === ActionTypes.SUCCESSFUL) {
        button.setAttribute('part', 'gridButton');
        this.leftButtons.appendChild(button);
      } else if (action.type === ActionTypes.IN_PROGRESS) {
        button.setAttribute('part', 'inProgressButton');
        this.leftButtons.appendChild(button);
      } else {
        button.setAttribute('part', 'gridIconButton');
        this.rightButtons.appendChild(button);
      }

      if (action.type === ActionTypes.COMPARE) {
        this.leftButtons.style.setProperty('display', 'none', 'important');
        this.content.style.setProperty('justify-content', 'center', 'important');
      }
    });
  }
  refresh(params: IAgGridActions): boolean {
    this.content.innerHTML = '';
    this.renderButtons(params);
    return true;
  }
  getGui(): HTMLElement {
    return this.content;
  }
}
